import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollEmployeeCustomFieldsResponse } from '../types';

export const getEmployeeCustomFieldsQuery = gql`
  query PayrollEmployeeCustomFields($userId: ID!) {
    payrollEmployeeCustomFields(userId: $userId) {
      userId
      fields
    }
  }
`;

export const getEmployeeCustomFields = (variables: { userId: string }) =>
  graphQLApi<PayrollEmployeeCustomFieldsResponse, { userId: string }>({
    query: getEmployeeCustomFieldsQuery,
    queryVariables: variables,
  });
